import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getArtifactRisks = (orgId, interactionId, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'FETCHING_ARTIFACT_RISKS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(
            `/ads/org/${orgId}/deals/interactions/${interactionId}/risks`,
            {
              params: {
                requestId: reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          //   console.log(response.data);
          if (response.status === 200) {
            await dispatch({
              type: 'FETCHING_ARTIFACT_RISKS_DONE',
              payload: response?.data,
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_ARTIFACT_RISKS_FAILED',
              payload: `Failed to fetch activity risks`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_ARTIFACT_RISKS_FAILED',
            payload: `Failed to fetch activity risks`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'FETCHING_ARTIFACT_RISKS_FAILED',
        payload: `Failed to fetch activity risks`,
      });
    }
  };
};

export default getArtifactRisks;
